var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResolutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.643 48.8878L46.5741 43.9567L39.5285 36.911L34.5973 41.8422L41.643 48.8878Z",
    fill: "#0C233C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8931 36.8134L13.7211 41.2368L19.4761 38.8559L15.425 42.9069L18.8103 46.2922L22.8726 42.2299L17.8963 54.2589L22.3197 56.087L27.2961 44.0579V50.9639H32.0806V44.0579L35.7819 53.0064L40.2053 51.1783L38.3434 46.6984L33.4912 41.8462L34.4052 40.9322C33.6491 40.7065 32.8367 40.6726 32.0468 40.8757C29.0226 41.6769 25.6599 40.887 23.2902 38.5173C19.6341 34.8612 19.7356 28.8693 23.6062 25.3373C27.0253 22.2228 32.4079 22.2115 35.8383 25.3373C38.445 27.707 39.3477 31.1938 38.5352 34.3421C38.3321 35.1546 38.3547 35.9897 38.5804 36.757L39.517 35.8204L44.4595 40.7629L51.546 43.6968L53.3741 39.2734L41.6949 34.4324H51.6927V29.6479H41.6949L48.7249 26.7365L46.8969 22.3131L39.8668 25.2244L47.7207 17.3706L44.3354 13.9853L36.4815 21.8392L40.0925 13.1277L35.6691 11.2996L32.0581 20.0111V13.5903H27.2735V20.0111L21.1462 5.21741L16.7227 7.04546L22.8501 21.8392L15.5153 14.5044L12.13 17.8897L19.4648 25.2244L13.7324 22.8435L11.9043 27.2669L17.6368 29.6479H6.52173V34.4324H17.6368L11.8818 36.8134H11.8931Z",
    fill: "#0C233C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolutionIcon);
export default __webpack_public_path__ + "static/media/ResolutionIcon.3f016d0a1d2e78fa6b9e9421af10a085.svg";
export { ForwardRef as ReactComponent };